import { cn } from "@/lib/utils";
import { FC, ReactNode, memo } from "react";

export const widthSubNav = 280;

type SubNavProps = {
  children: ReactNode;
};

const SubNav: FC<SubNavProps> = ({ children }) => {
  return (
    <div
      className={cn(
        "h-[calc(100vh-70px)] fixed [transition:all_0.2s_ease-in-out] top-[70px] overflow-hidden "
      )}
      style={{ width: widthSubNav }}
    >
      {children}
    </div>
  );
};

export default memo(SubNav);
